import isEmpty from 'lodash/isEmpty';
import throttle from 'lodash/throttle';

import * as types from './types';
import {parseApiResult} from './utils';

export const syncCategories = (force = false) => {
  return (dispatch, getState, {categories}) => {
    const locale = getState()?.localization?.locale;

    if (force || getState()?.categories?.locale !== locale || isEmpty(getState()?.categories?.dict)) {
      dispatch({type: types.CATEGORIES_REQUEST});

      return categories
        .getAllCategories({params: {locale}})
        .then((results) => {
          dispatch({
            type: types.CATEGORIES_SUCCESS,
            payload: {
              ...parseApiResult(results),
              locale,
            },
          });
        })
        .catch((error) =>
          dispatch({
            type: types.CATEGORIES_ERROR,
            error,
          }),
        );
    }
  };
};

const _throttledSyncCategories = throttle((dispatch, force) => dispatch(syncCategories(force)), 10000);

export const getCategories = (force) => {
  return (dispatch) => {
    return _throttledSyncCategories(dispatch, force);
  };
};
